import { FactoryProvider } from '@angular/core';
import { CONFIG_INITIALIZER, SiteContextConfig } from '@spartacus/core';
import { StoreContextConfigInitializer, initStoreContextConfig } from './store-context-config-initializer';

/**
 * Провайдит CONFIG_INITIALIZER'ы в конфигурационный модуль спартакуса
 */
export const сonfigInitializerProviders: FactoryProvider[] = [
  {
    provide: CONFIG_INITIALIZER,
    useFactory: initStoreContextConfig,
    deps: [StoreContextConfigInitializer, SiteContextConfig],
    multi: true,
  },
];
